export function isUserCenterStudent(auth) {
  if (!auth || typeof auth !== "object") return false;
  const type = auth.type;
  if (type === 0 || type === "0") return true;
  if (type === 1 || type === "1") return false;
  return Boolean(auth.center);
}

export function isUserOnlineStudent(auth) {
  if (!auth || typeof auth !== "object") return false;
  const type = auth.type;
  if (type === 1 || type === "1") return true;
  if (type === 0 || type === "0") return false;
  return !auth.center;
}

export function collectOwnedCourseIds(myWeeksResponse) {
  const ownedIds = new Set();
  const data = myWeeksResponse?.data?.data;

  if (Array.isArray(data)) {
    data.forEach((course) => {
      if (course?.id != null) ownedIds.add(String(course.id));
    });
  }

  return ownedIds;
}

export function isCourseOwnedByUser(course, ownedCourseIds) {
  const attrs = course?.attributes || {};
  const ownedFlag = attrs.Owned ?? attrs.owned ?? attrs.is_enrolled ?? attrs.isEnrolled;
  const fromAttr =
    ownedFlag === true ||
    ownedFlag === 1 ||
    ownedFlag === "1" ||
    ownedFlag === "true" ||
    String(ownedFlag).toLowerCase() === "true";

  const courseId = course?.id;
  const fromSet =
    ownedCourseIds &&
    courseId != null &&
    (ownedCourseIds.has(String(courseId)) || ownedCourseIds.has(Number(courseId)));

  return Boolean(fromSet || fromAttr);
}

export function isCourseContentOwned(payData = {}, courseId, ownedCourseIds) {
  const ownedFlag =
    payData.owned ??
    payData.Owned ??
    payData.is_enrolled ??
    payData.isEnrolled;

  const fromPay =
    ownedFlag === true ||
    ownedFlag === 1 ||
    ownedFlag === "1" ||
    ownedFlag === "true" ||
    String(ownedFlag).toLowerCase() === "true";

  if (fromPay) return true;

  if (!ownedCourseIds || courseId == null) return false;
  return (
    ownedCourseIds.has(String(courseId)) ||
    ownedCourseIds.has(Number(courseId))
  );
}
